import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spacer,
  Wrap,
  WrapItem,
  useToast,
} from '@chakra-ui/react';
import axios from 'axios';
import SingleMapField from './SingleMapField';
interface MapFieldModalProps {
  isOpen: boolean;
  onClose: () => void;
  documentID: any;
  count: number;
  setCount: any;
  downloadFile: any;
}

interface MapFieldData {
  variationid: number;
  documentid: number;
  fields: any;
}

interface singleFieldData {
  fieldid: number;
  documentid: number;
  name: string;
  type: string;
  mapped_name: string;
}

type FieldDataArray = singleFieldData[];

function MapFormModal({
  isOpen,
  onClose,
  documentID,
  count,
  setCount,
  downloadFile,
}: MapFieldModalProps) {
  const [mapFieldData, setMapFieldData] = useState<MapFieldData>({
    variationid: 0,
    documentid: documentID,
    fields: [],
  });
  const [fieldsData, setFieldsData] = useState<FieldDataArray>([]);
  const [dropDownOptions, setDropDownOptions] = useState();
  let toast = useToast();

  useEffect(() => {
    const baseurl = process.env.REACT_APP_SERVER_SCENARIOS_BASE_URL as string;
    const tokenUrl = process.env.REACT_APP_SCENARIO_TOKEN_URL as string;

    // Function to fetch the token and then the forms
    let fetchForms = async () => {
      try {
        let tokenResponse = await axios.get(tokenUrl);

        if (tokenResponse.data.success) {
          let formsResponse = await axios.get(
            baseurl + '/Appeal/get_available_fields',
            {
              headers: {
                Pragma: 'no-cache',
                Authorization: 'Bearer ' + tokenResponse.data.token,
              },
            }
          );
          if (formsResponse.status === 200) {
            setDropDownOptions(formsResponse.data);
          } else {
            throw new Error(
              `Failed to fetch forms: ${
                formsResponse.data.message || 'Unknown error'
              }`
            );
          }
        } else {
          throw new Error(
            `Failed to retrieve auth token: ${
              tokenResponse.data.message || 'Unknown error'
            }`
          );
        }
      } catch (error: any) {
        console.error(
          'Error fetching forms:',
          error.response ? error.response.data : error.message
        );
      }
    };

    fetchForms();
  }, [mapFieldData]);

  useEffect(() => {
    const baseurl = process.env.REACT_APP_PAYER_FORM_BASE_URL as string;
    const tokenUrl = process.env.REACT_APP_TOKEN_URL_PAYER_FORM as string;

    // Function to fetch the token and then the forms
    const fetchForms = async () => {
      try {
        const tokenResponse = await axios.get(tokenUrl);

        if (tokenResponse.data.success) {
          const formsResponse = await axios.get(
            baseurl +
              '/App/api/get_document_variations?documentid=' +
              documentID,
            {
              headers: {
                Pragma: 'no-cache',
                Authorization: 'Bearer ' + tokenResponse.data.token,
              },
            }
          );

          if (formsResponse.data.success) {
            const variations = formsResponse.data.fields;
            setMapFieldData(prevData => ({
              ...prevData,
              fields: variations,
            }));
          } else {
            throw new Error('Failed to fetch forms');
          }
        } else {
          throw new Error('Failed to retrieve auth token');
        }
      } catch (error) {
        console.error('Error fetching forms:', error);
      }
    };

    fetchForms();
  }, [documentID]);

  const handleChangeDefaultValue = (fieldId: number, value: string) => {
    // Update the mapFieldData state
    const updatedFields = mapFieldData.fields.map((field: any) => {
      if (field.fieldid === fieldId) {
        return { ...field, defaultvalue: `FIELD:${value}` };
      }
      return field;
    });

    setMapFieldData(prevState => ({
      ...prevState,
      fields: updatedFields,
    }));

    // Update the fieldsData state
    setFieldsData(prevState => {
      const fieldIndex = prevState.findIndex(
        field => field.fieldid === fieldId
      );
      const newFieldData = {
        fieldid: fieldId,
        documentid: documentID,
        name: updatedFields.find((field: any) => field.fieldid === fieldId)
          .fieldname,
        type:
          updatedFields
            .find((field: any) => field.fieldid === fieldId)
            .type.trim() === ''
            ? 'text'
            : updatedFields.find((field: any) => field.fieldid === fieldId)
                .type,
        mapped_name: `FIELD:${value}`,
      };

      if (fieldIndex !== -1) {
        // Update existing field
        const updatedFieldsData = [...prevState];
        updatedFieldsData[fieldIndex] = newFieldData;
        return updatedFieldsData;
      } else {
        // Add new field
        return [...prevState, newFieldData];
      }
    });
  };

  const saveFieldMapping = async () => {
    const baseurl = process.env.REACT_APP_PAYER_FORM_BASE_URL as string;
    const tokenUrl = process.env.REACT_APP_SCENARIO_TOKEN_URL as string;
    try {
      const tokenResponse = await axios.get(tokenUrl);
      if (tokenResponse.data.success) {
        const formsResponse = await axios.post(
          baseurl + '/App/api/save_field_mapping',

          fieldsData,

          {
            headers: {
              Pragma: 'no-cache',
              Authorization: 'Bearer ' + tokenResponse.data.token,
            },
          }
        );
        if (formsResponse.data.success) {
          toast({
            title: 'Success',
            position: 'top',
            description: 'Field Mapping Successfully Saved!',
            status: 'success',
            duration: 3000,
            isClosable: true,
          });
          setCount(count + 1);
        } else {
          throw new Error('Failed to upload data');
        }
      } else {
        throw new Error('Failed to retrieve auth token');
      }
    } catch (error) {
      console.error('Error Uploading data:', error);
    }
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={() => {
          onClose();
          setMapFieldData((prevFormData: any) => ({
            ...prevFormData,
            fields: [],
          }));
        }}
        size="6xl"
      >
        <ModalOverlay
          onClick={() => {
            onClose();
            setMapFieldData((prevFormData: any) => ({
              ...prevFormData,
              fields: [],
            }));
          }}
        />
        <ModalContent>
          <ModalHeader textAlign="center">Map Form Fields</ModalHeader>
          <ModalCloseButton color="white" bg=" #002677" />
          <ModalBody>
            <Flex textAlign="center" flexDir="column">
              <Flex justifyContent="flex-end">
                <Button
                  bg="#002677"
                  textColor="white"
                  onClick={() => downloadFile(documentID, true)}
                >
                  Download with Marked Fields
                </Button>
              </Flex>
              <Wrap mt="20px">
                {mapFieldData && mapFieldData.fields
                  ? mapFieldData.fields.map((data: any) => (
                      <WrapItem key={data.fieldid}>
                        <Box width="300px">
                          <SingleMapField
                            fieldData={data}
                            dropDownOptions={dropDownOptions}
                            handleChangeDefaultValue={handleChangeDefaultValue}
                          />
                        </Box>
                      </WrapItem>
                    ))
                  : ''}
              </Wrap>
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button
              bg="#002677"
              textColor="white"
              mr={3}
              onClick={() => {
                onClose();
              }}
            >
              Cancel
            </Button>
            <Spacer />
            <Button
              variant="ghost"
              bg="#002677"
              textColor="white"
              onClick={() => {
                saveFieldMapping();
                onClose();
                setFieldsData([]);
              }}
            >
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default MapFormModal;
